import { createSlice } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  dateRange: {
    dt1: null,
    dt2: null,
    textValue: ''
  },
  subType: {
    id: '',
    description: ''
  },
  mode: {
    ixMode: null,
    require_date: false,
    sMode: ''
  },
  account: {
    ixAcc: 0,
    sAcc: ''
  },
  brch: {
    ixBrch: 0,
    sBrch: ''
  },
  error: '',
  compact: false,
  allPagesLoaded: false,
  results: [],
  page: 0,
  loadedPages: 0,
  rowsPerPage: 10,
  batch: 100,
  loading: false
};

const slice = createSlice({
  name: 'sl3',
  initialState: INITIAL_STATE,
  reducers: {
    setDateRange(state, action) {
      state.dateRange = action.payload;
    },
    setSubType(state, action) {
      state.subType = action.payload;
    },
    setAccount(state, action) {
      state.account = action.payload;
    },
    setResults(state, action) {
      state.results = action.payload;
    },
    addResults(state, action) {
      state.results = [...state.results, ...action.payload];
    },
    resetResults(state) {
      state.results = [];
    },
    setAllPagesLoaded(state, action) {
      state.allPagesLoaded = action.payload;
    },
    setLoadedPages(state, action) {
      state.loadedPages = action.payload;
    },
    setPage(state, action) {
      state.page = action.payload;
    },
    setRowsPerPage(state, action) {
      state.rowsPerPage = action.payload;
    },
    setBranch(state, action) {
      state.brch = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setCompact(state, action) {
      state.compact = action.payload;
    },
    setMode(state, action) {
      state.mode = action.payload;
    },
    clear() {
      return INITIAL_STATE;
    },
    restore(_, action) {
      return { ...INITIAL_STATE, ...(action.payload || {}) };
    }
  }
});

const sl3Reducer = slice.reducer;

export const {
  setMode,
  setDateRange,
  setSubType,
  setAccount,
  setCompact,
  setResults,
  addResults,
  setRowsPerPage,
  setPage,
  setLoadedPages,
  setAllPagesLoaded,
  clear,
  resetResults,
  restore,
  setBranch
} = slice.actions;

export default sl3Reducer;
